
angular.module('trainerWebApp.services').factory('untitledFieldService', function() {

  function nameEmptyFields(params) {
    var collection = params.collection || [];
    var nameProp = params.nameProp || 'name';
    var ignoreIf = params.ignoreIf || 'editorEnabled';

    var untitledPrefix = 'Untitled';

    var lastUntitledFieldNumber = Math.max.apply(Math, _.map(collection, function (field) {
      var name = field[nameProp];
      if (!name || name.substr(0, 8) != untitledPrefix)
        return 0;

      if (name === untitledPrefix) // Untitled
        return 1;

      name = name.replace(untitledPrefix, '').trim();
      if (name.match(/\D+/)) // fields like "Untitled 1Hello" will be ignored
        return 0;

      return parseInt(name);
    }));

    for (var i = 0, c = collection.length; i < c; i++) {
      if (collection[i][nameProp] || collection[i][ignoreIf]) continue;

      // field lacks a name and is not being edited
      collection[i][nameProp] = 'Untitled';
      lastUntitledFieldNumber++;

      if (lastUntitledFieldNumber > 1)
        collection[i][nameProp] += ' ' + lastUntitledFieldNumber;
    }
  }

  return {
    nameEmptyFields: nameEmptyFields
  };
});
